import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function Blog() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Blog</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            The RegTech engineering blog
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Field notes on compliance operations: control design, evidence patterns, privacy ops, SOC engineering, and resilience.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
            <Link to="/contact#contact-form" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white hover:opacity-95">
              Suggest a topic →
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Categories</div>
            <div className="mt-6 grid gap-3 md:grid-cols-2 lg:grid-cols-4">
              {[
                "DPDPA & privacy ops",
                "Evidence automation",
                "SOC engineering",
                "Third-party risk",
                "OT/ICS security",
                "Cloud security & CNAPP",
                "Audit readiness",
                "Metrics & dashboards",
              ].map((c) => (
                <div key={c} className="rounded-2xl border border-border-subtle bg-white/5 p-5 text-sm font-semibold text-text-secondary">
                  {c}
                </div>
              ))}
            </div>
            <div className="mt-6 text-sm text-text-tertiary">
              In a future iteration, we can add a full blog engine with MDX, search, tags, and author pages.
            </div>
          </div>

          <div className="mt-10 grid gap-4 lg:grid-cols-3">
            {[ 
              {
                t: "DPDPA: Building DSAR workflows that meet 30-day SLAs",
                d: "Design intake, identity verification, fulfillment, and audit trails with minimal manual effort.",
                href: "/frameworks/india/dpdpa",
              },
              {
                t: "From control statement to evidence: making controls testable",
                d: "A system for defining evidence sources, retention and audit methods that survive scrutiny.",
                href: "/technology-mapping",
              },
              {
                t: "Dashboards that matter: Board, CISO, and auditor views",
                d: "How to design executive metrics with traceability back to controls and evidence.",
                href: "/dashboards",
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5">
                  <Link to={x.href} className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                    Open reference →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Request content</div>
            <div className="mt-3 text-sm text-text-secondary">Want a post on a specific framework, tool, or control domain? Tell us.</div>
            <div className="mt-6">
              <ContactForm title="Content request" subtitle="We can also turn it into a webinar." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
